import { CompaniesApiFactory, V1Company } from '@vacancorp/enterprise-for-client.vacanservice.com'
import { Company, CompanyDetails, AppService } from '@/models'
import { api, ApiResponse, ListResponse, createApiError } from './base'

function createCompanies(rawCompanies?: V1Company[]): Company[] {
  if (!rawCompanies) return [] as Company[]

  return rawCompanies.map((c: V1Company): Company => {
    return new Company({
      id: c.id,
      name: c.name,
      code: c.code,
      zipCode: c.zipCode,
      address: c.address,
      facilityName: c.facilityName,
      details: new CompanyDetails({
        services: c.details?.services?.map(s => new AppService({ name: s.name, options: s.options })),
        archived: c.details?.archived,
      })
    })
  })
}

export const NewCompaniesApiFunc = () => {
  const webAdapter = CompaniesApiFactory(undefined, api.defaults.baseURL, api)

  return {
    adminListCompanies: async (filter?: string, page?: number): Promise<ApiResponse<ListResponse<Company>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.adminListCompanies(filter, page)
        data = createCompanies(res.data.companies)
        currentPage = res.data.currentPage
        totalPage = res.data.totalPage
      } catch (e) {
        data = [] as Company[]
        err = createApiError(e)
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1
        },
        err,
      }
    },

    adminGetCompany: async (companyId: string): Promise<ApiResponse<Company | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.adminGetCompany(companyId)
        data = createCompanies([res.data])[0]
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    adminArchiveCompany: async (companyId: string): Promise<ApiResponse<void>> => {
      let data, err

      try {
        await webAdapter.adminArchiveCompany(companyId)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    adminUpdateCompany: async (companyId: string, company: Company): Promise<ApiResponse<Company | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.adminUpdateCompany(companyId, {data: company})
        data = new Company(res.data)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    adminCreateCompany: async (company: Company): Promise<ApiResponse<Company | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.adminCreateCompany({data: company})
        data = new Company(res.data)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    getCompany: async (companyId: string): Promise<ApiResponse<Company | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.getCompany(companyId)
        data = createCompanies([res.data])[0]
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    }
  }
}
